'use strict';
var $ = require('../internals/export');
var exec = require('../internals/regexp-exec');

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/es.regexp.exec.js